import {Component, Input, OnInit} from '@angular/core';
import {AbstractControl, FormGroup} from '@angular/forms';

import {
  peopleTargetedAnswers, typeOfCampsAnswers, topicsDiscussedAnswers
} from '../../constants/funding-request-answers/camps-question-answers.const';

import {createNumberMask} from 'text-mask-addons/dist/textMaskAddons';
import {FormValidationService} from '../../../../../../../services/form-validation/form-validation.service';
import {checkForValue} from '../../../../../../organisation/capacity-spectrum/components/capacity-spectrum/store/capacity-spectrum.model';

@Component({
  selector: 'app-camps',
  templateUrl: './camps.component.html',
  styleUrls: ['./camps.component.scss']
})
export class CampsComponent implements OnInit {

  theme: 'dark' | 'light' = 'light';
  style: 'default' | 'bordered' = 'default';

  @Input() campsForm: FormGroup;
  @Input() formValid: boolean;
  @Input() isReadOnly: boolean;
  @Input() fromReview: boolean;

  peopleTargetedOptions = peopleTargetedAnswers;
  typeOfCampsOptions = typeOfCampsAnswers;
  topicsDiscussedOptions = topicsDiscussedAnswers;
  numberMask: any;

  constructor(public formValidationService: FormValidationService) {
  }

  ngOnInit() {
    this.numberMask = createNumberMask({
      prefix: '',
      suffix: '',
      allowDecimal: false,
      allowNegative: false,
      includeThousandsSeparator: false
    });
  }

  checkOther(value: string | boolean, selectedValue: string, controlParent: AbstractControl, controlChild: AbstractControl) {
    checkForValue(value, selectedValue, controlParent, controlChild);
  }
}
